import { render, staticRenderFns } from "./student-enrollment-report.vue?vue&type=template&id=139992b6&"
import script from "./student-enrollment-report.vue?vue&type=script&lang=js&"
export * from "./student-enrollment-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports